<div
  *ngIf="menuItems?.length && shouldDisplayThreeDotsButton"
  class="icon-wrapper"
  (mouseenter)="openMenu()"
  (mouseleave)="onMouseLeave()"
  (click)="$event.stopPropagation()"
  [matMenuTriggerFor]="menu"
  #menuTrigger="matMenuTrigger"
>
  <mat-icon class="three-dots-icon">more_horiz</mat-icon>
</div>

<mat-menu
  [overlapTrigger]="false"
  [hasBackdrop]="false"
  class="dropdown-menu-with-icons"
  #menu="matMenu"
  [xPosition]="xPosition"
>
  <div
    (mouseenter)="onMenuHover()"
    (mouseleave)="onMouseLeave()"
  >
    <button
      mat-menu-item
      [hidden]="true"
    >
      <!--      This is workaround, to prevent first menu-item highlighting-->
    </button>

    <ng-container *ngFor="let menuItem of menuItems">
      <button
        *ngIf="shouldDisplay(menuItem) | async"
        (mouseenter)="onHoverAction()"
        (mouseleave)="onHoverAction()"
        class="dropdown-menu-with-icons-item"
        [class.bottom-line]="menuItem.bottomLine"
        [ngStyle]="{'width': width}"
        [class.top-line]="menuItem.topLine"
        (click)="onClick(menuItem)"
        mat-menu-item
      >
        <mat-icon class="menu-icon material-icons-outlined">{{menuItem.icon}}
        </mat-icon>
        {{menuItem.text}}
      </button>
    </ng-container>
  </div>
</mat-menu>
